import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavigationModule } from '../../Components/Navigation/navigationConfig';

interface TopDockNavItemProps {
  module: NavigationModule;
  isActive: boolean;
  onClick?: () => void;
}

const TopDockNavItem: React.FC<TopDockNavItemProps> = ({ module, isActive, onClick }) => {
  const location = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onClick) {
        onClick();
      }
    }
  };

  return (
    <Link
      to={module.route}
      className={`top-dock-nav-item ${isActive ? 'active' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={module.label}
      aria-current={isActive ? 'page' : undefined}
      title={module.label}
      role="button"
      tabIndex={0}
    >
      <i className={`top-dock-nav-item-icon ${module.icon}`} aria-hidden="true"></i>
      <span className="top-dock-nav-item-label">{module.label}</span>
    </Link>
  );
};

export default TopDockNavItem;

